<template>
  <section class="grouped">
    <div v-if="venue.contacts.length === 0" class="elements">
      No hay nada añadido
    </div>
    <div v-else class="elements">
      <b-row class="font-weight-bold">
        <b-col cols="5">
          <span>
            Dirección
          </span>
        </b-col>
      </b-row>
      <b-row v-for="element in venue.addresses" :key="element.id">
        <b-col cols="5">
          <span>
            {{ element.venueAddress.name }}
          </span>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ListVenueAddress',
  computed: {
    ...mapGetters({ venue: 'venues/current' })
  }
}
</script>

<style lang="less" scoped>
@import "listVenueAddress";
</style>
